import LogoImage from 'assets/images/logo.svg'

export const Logo = () => {
  return <img className="h-full w-full" src={LogoImage} alt="logo" />
}
